var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-input-number',{key:_vm.inputKey,attrs:{"value":_vm.value,"size":_vm.size,"precision":_vm.decimalLength,"min":_vm.minValue,"max":_vm.max,"step":_vm.stepValue},on:{"change":_vm.changeHanlder}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a348598","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/fm/FmNumberDigitBox.vue
// module id = null
// module chunks = 